/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationOptionsDataQueryResponse } from './IntegrationOptionsDataQueryResponse';
import {
    IntegrationOptionsDataQueryResponseFromJSON,
    IntegrationOptionsDataQueryResponseFromJSONTyped,
    IntegrationOptionsDataQueryResponseToJSON,
} from './IntegrationOptionsDataQueryResponse';

/**
 * 
 * @export
 * @interface IntegrationOptionGroupQueryResponse
 */
export interface IntegrationOptionGroupQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof IntegrationOptionGroupQueryResponse
     */
    kind: IntegrationOptionGroupQueryResponseKindEnum;
    /**
     * 
     * @type {IntegrationOptionsDataQueryResponse}
     * @memberof IntegrationOptionGroupQueryResponse
     */
    options: IntegrationOptionsDataQueryResponse;
}


/**
 * @export
 */
export const IntegrationOptionGroupQueryResponseKindEnum = {
    Email: 'email',
    Calendar: 'calendar',
    Message: 'message',
    Other: 'other'
} as const;
export type IntegrationOptionGroupQueryResponseKindEnum = typeof IntegrationOptionGroupQueryResponseKindEnum[keyof typeof IntegrationOptionGroupQueryResponseKindEnum];


/**
 * Check if a given object implements the IntegrationOptionGroupQueryResponse interface.
 */
export function instanceOfIntegrationOptionGroupQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function IntegrationOptionGroupQueryResponseFromJSON(json: any): IntegrationOptionGroupQueryResponse {
    return IntegrationOptionGroupQueryResponseFromJSONTyped(json, false);
}

export function IntegrationOptionGroupQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationOptionGroupQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'options': IntegrationOptionsDataQueryResponseFromJSON(json['options']),
    };
}

export function IntegrationOptionGroupQueryResponseToJSON(value?: IntegrationOptionGroupQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'options': IntegrationOptionsDataQueryResponseToJSON(value.options),
    };
}

